module.exports = __webpack_public_path__ + "static/media/img_bg2@2x.666424c1.png";